var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6904_2350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4902 6.8151H17.6902V4.9301C17.6902 4.6111 17.4292 4.3501 17.1102 4.3501H11.8902C11.5712 4.3501 11.3102 4.6111 11.3102 4.9301V6.8151H5.51018C5.19118 6.8151 4.93018 7.0761 4.93018 7.3951C4.93018 7.7141 5.19118 7.9751 5.51018 7.9751H7.42418V24.0701C7.42418 24.3891 7.68518 24.6501 8.00418 24.6501H20.9962C21.3152 24.6501 21.5762 24.3891 21.5762 24.0701V7.9751H23.4902C23.8092 7.9751 24.0702 7.7141 24.0702 7.3951C24.0702 7.0761 23.8092 6.8151 23.4902 6.8151ZM12.4702 5.5101H16.5302V6.6701H12.4702V5.5101ZM20.4162 23.4901H8.58418V7.9751H20.4162V23.4901ZM17.6902 11.1071V20.3871C17.6902 20.7061 17.4292 20.9671 17.1102 20.9671C16.7912 20.9671 16.5302 20.7061 16.5302 20.3871V11.1071C16.5302 10.7881 16.7912 10.5271 17.1102 10.5271C17.4292 10.5271 17.6902 10.7591 17.6902 11.1071ZM12.4702 11.1071V20.3871C12.4702 20.7061 12.2092 20.9671 11.8902 20.9671C11.5712 20.9671 11.3102 20.7061 11.3102 20.3871V11.1071C11.3102 10.7881 11.5712 10.5271 11.8902 10.5271C12.2092 10.5271 12.4702 10.7591 12.4702 11.1071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56 -269.7V218.66H-121.8V-269.7H395.56ZM397.88 -272.02H-124.12V220.98H397.88V-272.02Z",
    fill: "#0000FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6904_2350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5c3c66432f75d906af31cb03eeac17e4.svg";
export { ForwardRef as ReactComponent };